import { Module } from 'vuex';
import { updateDocument } from '@/document-manipulator/update-document/store/update-document.store';
import { RootState } from '@/store/store';
import { createPage } from '@/document-manipulator/create-page/store/create-page.store';
import { deletePage } from '@/document-manipulator/delete-page/store/delete-page.store';

export const documentManipulator: Module<{}, RootState> = {
  namespaced: true,
  modules: {
    createPage,
    deletePage,
    updateDocument,
  },
};
